import { FC, ReactNode } from "react";

import LocalImages from "../../../../assets/images/local-images";
import CheckboxLabel from "./styles/CheckboxLabel.styled";
import CheckBoxRoot from "./styles/CheckBoxRoot.styled";
import { Error } from "./styles/Error.styled";
import HiddenCheckbox from "./styles/HiddenCheckbox.styled";
import StyledCheckbox from "./styles/StyledCheckbox.styled";

interface CheckboxProps {
  label: ReactNode;
  checked: boolean;
  onChange: (value: boolean) => void;
  error: string | null;
}

const Checkbox: FC<CheckboxProps> = ({ checked, label, onChange, error }) => {
  const images = LocalImages.shared.images!;
  return (
    <CheckBoxRoot>
      <CheckboxLabel data-testid="pax-consent-checkbox">
        <HiddenCheckbox
          data-testid="pax-consent-checkbox-hidden"
          checked={checked}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
        />
        <StyledCheckbox>
          <img alt="checkmark" src={images.icons.checkboxTick} />
        </StyledCheckbox>
        {label}
      </CheckboxLabel>
      {error ? <Error>{error}</Error> : null}
    </CheckBoxRoot>
  );
};

export default Checkbox;
